import type { ObjectData } from '@os/doc';
import { RichText } from '../text/RichText';

export function TextObject({ o }: { o: Extract<ObjectData, { type: 'text' }> }) {
  return (
    <div
      data-rich
      className="h-full w-full break-words font-sans text-[var(--canvas-ink,#141414)]"
      style={{ fontSize: o.fontSize, lineHeight: 1.3, color: typeof o.style.color === 'string' ? o.style.color : undefined }}
    >
      <RichText doc={o.content} fallback={o.text} />
    </div>
  );
}
